module.exports = __webpack_public_path__ + "static/img/yes.324288e3.svg";